import { isFunction as _isFunction, has as _has } from 'lodash';

import { InvalidMethodProvidedException } from './Exceptions';

class Common {
  constructor(authConfig, onLoadingStart = () => {}, onLoadingEnd = () => {}) {
    if (!_isFunction(onLoadingStart) || !_isFunction(onLoadingEnd)) {
      throw new InvalidMethodProvidedException(
        'Invalid arguments, expect "onLoadingStart" and "onLoadingEnd" to be functions',
      );
    }

    this.__authConfig = authConfig;
    this.__onLoadingStart = onLoadingStart;
    this.__onLoadingEnd = onLoadingEnd;
  }

  setConfiguration = config => {
    if (_has(config, 'authConfig')) {
      this.__authConfig = config.authConfig;
    }
    if (_has(config, 'onLoadingStart')) {
      this.__onLoadingStart = config.onLoadingStart;
    }
    if (_has(config, 'onLoadingEnd')) {
      this.__onLoadingEnd = config.onLoadingEnd;
    }
  };

  get authConfig() {
    return this.__authConfig;
  }
}

export default Common;
